"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiMenuThemeOptions = void 0;
const material_1 = require("@mui/material");
exports.MuiMenuThemeOptions = {
    defaultProps: {
        elevation: 4,
        autoFocus: false,
    },
    styleOverrides: {
        list: ({ theme }) => ({
            padding: theme.spacing(0.5),
            [`.${material_1.dividerClasses.root}`]: {
                marginTop: theme.spacing(0.75),
                marginBottom: theme.spacing(0.75),
                // this resets the horizontal padding
                // set above and ensures the divider runs
                // end to end
                marginLeft: theme.spacing(-0.5),
                marginRight: theme.spacing(-0.5),
            },
        }),
        paper: {
            minWidth: 228,
        },
    },
};
